import { createAction, props } from '@ngrx/store';
import { IdPsConfigurationState } from 'src/app/AppState';

export const getIdPsConfigurationRequest = createAction('[IdPsConfiguration] Get IdPs configuration Request', props<{ forceAuthentication: boolean }>());
export const getIdPsConfigurationDone = createAction('[IdPsConfiguration] Get IdPs configuration Done', props<{ configuration: IdPsConfigurationState }>());
export const getIdPsConfigurationError = createAction('[IdPsConfiguration] Get IdPs configuration Request Error', props<{ configuration: IdPsConfigurationState }>());

export const resetIdPsConfiguration = createAction('[IdPsConfiguration] Reset IdPs configuration');